var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7319",
    d: "M15 6.665h-.834V5c0-2.3-1.866-4.167-4.166-4.167-2.3 0-4.167 1.867-4.167 4.167v1.666H5c-.917 0-1.667.75-1.667 1.667v8.333c0 .917.75 1.667 1.667 1.667h10c.916 0 1.666-.75 1.666-1.667V8.332c0-.917-.75-1.667-1.666-1.667zm-5 7.5c-.917 0-1.667-.75-1.667-1.666 0-.917.75-1.667 1.667-1.667.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666zm2.583-7.5H7.416V5c0-1.425 1.159-2.584 2.584-2.584S12.583 3.574 12.583 5v1.666z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockMenu);
export default __webpack_public_path__ + "static/media/lock-menu.76533856.svg";
export { ForwardRef as ReactComponent };